import BaseUtil from "../../../util/BaseUtil";
import BusinessConstants from "../../../constant/BusinessConstants";

const type = `@@ActionType/UPDATE@${__filename}`;

const hrCategorys = [BusinessConstants.QUALITY_CONTROL_TYPE.HR_WORKYEARS, BusinessConstants.QUALITY_CONTROL_TYPE.HR_EDUBG, BusinessConstants.QUALITY_CONTROL_TYPE.HR_JOBTITLE];
const dimissionCategorys = [BusinessConstants.QUALITY_CONTROL_TYPE.DIMISSION_WORKYEARS, BusinessConstants.QUALITY_CONTROL_TYPE.DIMISSION_EDUBG,
    BusinessConstants.QUALITY_CONTROL_TYPE.DIMISSION_JOBTITLE, BusinessConstants.QUALITY_CONTROL_TYPE.DIMISSION_NURSE_COUNT];

const initState = {
    selectedUnitIds: [],
    natureOptions: null, // 职工性质选项
    selectedNature: null, // 选中的职工性质
    quarterDate: null, // 选中的日期
    data: null, // 当前分类下对应数据
    dataLoading: false, // 数据加载
    clickedItem: {
        title: null,
        category: null,
    }, // 点中的分类，统计表柱状图

    detailDrawerVisible: false, // 详情
    detailTitle: null, // 详情drawer title
    detailRecord: null, // 点击中的data record
    detailDataLoading: false, // 详情数据加载
    detailData: null, // 详情数据
};

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);

export {
    update,
    reset,
    hrCategorys,
    dimissionCategorys,
};
export default viewModel;
